module.exports = __webpack_public_path__ + "static/media/not-allowed.5aca35ea.svg";